import * as React from 'react';
import { FC } from 'react';
import { CopyUrlButtonModel } from './CopyUrlButtonModel';

const CopyUrlButton: FC<CopyUrlButtonModel> = (props) => {
  const [buttonText, setButtonText] = React.useState('Kopier lenke');
  const [buttonBusy, setButtonBusy] = React.useState(false);

  const handleClick = async () => {
    setButtonBusy(true);
    try {
      await navigator.clipboard.writeText(props.url);
      setButtonText('Lenke kopiert');
      setInterval(() => {
        setButtonText('Kopier lenke');
        setButtonBusy(false);
      }, 3000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        disabled={buttonBusy}
        className='btn-primary w-full tablet:w-auto justify-center'
      >
        {buttonText}
      </button>
    </>
  );
};
export default CopyUrlButton;
